import React, { useState } from "react";
import PropTypes from 'prop-types'
// import { useSelector } from "react-redux";
import profileImage from "../../css/images/profile-image.svg";
// import { ProfileApis } from "../../API/Login/ProfileApi.js";
import UploadProfileImage from "../../Components/UploadProfileImage/UploadProfileImage.js";
// import ErrorHandle from "../../Components/ErrorHandle.js";
// import Toasts from "../Toasts/Toasts.js";

const ProfileImageUpdate = ({ businessProfileData }) => {
    // const { frProUser } = useSelector((state) => state?.Users);
    const [openModal, setOpenModal] = useState(false);
    const [profileImg, setProfileImg] = useState("");


    return (
        <>
            <div className="image-holder-main position-relative">
                <div className="image-holder overflow-hidden position-relative">
                    <img
                        src={businessProfileData?.profileImg || profileImg || profileImage}
                        alt="profileImage"
                        height={160}
                        width={160}
                        style={{ objectFit: 'cover' }}
                    />
                </div>
                <button
                    className="btn-upload position-absolute start-50 translate-middle-x"
                    style={{ bottom: '20px' }}
                    onClick={() => setOpenModal(true)}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M12 5V19M5 12H19"
                            stroke="#fff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                    </svg>
                    {/* </label> */}
                </button>
            </div>

            <UploadProfileImage
                setOpenModal={setOpenModal}
                openModal={openModal}
                setProfileImg={setProfileImg}
                businessProfileData={businessProfileData}
            />
        </>
    );
};

export default ProfileImageUpdate;
ProfileImageUpdate.propTypes = {
    businessProfileData: PropTypes.any,
}